import { Component, HostListener, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IFundraiser } from '../../models/fundraiser.model';
import { BannerModule } from 'src/app/common/banner/banner.module';
import { ApiService, FundraiserService, UtilService, VariablesService, VwoService } from 'src/app/shared/services';
import { PlaceholderLoaderModule } from 'src/app/common/placeholder-loader/placeholder-loader.module';
import { StoryModule } from 'src/app/story/story.module';
import { HospitalDoctorContactModule } from 'src/app/common/hospital-doctor-contact/hospital-doctor-contact.module';
import { StoryDocsModule } from 'src/app/common/story-docs/story-docs.module';
import { InViewportModule } from 'ng-in-viewport';
import { SipTopBannerModule } from 'src/app/common/sip-top-banner/sip-top-banner.module';
import { EndFundraiserBannerModule } from 'src/app/common/end-fundraiser-banner/end-fundraiser-banner.module';
import { FundraiserSIPBannerModule } from 'src/app/common/fundraiser-sipbanner/fundraiser-sipbanner.module';
import { ThankyouBannerModule } from 'src/app/common/thankyou-banner/thankyou-banner.module';
import { ModuleLoaderModule } from 'src/app/common/module-loader/module-loader.module';
import { IUser } from 'src/app/shared/models';
import { MatExpansionModule } from '@angular/material/expansion';
import { BenficiaryCardModule } from 'src/app/common/benficiary-card/benficiary-card.module';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';
import { DonationMethodsModule } from 'src/app/common/donation-methods/donation-methods.module';
import { ReferFriendModule } from 'src/app/common/refer-friend/refer-friend.module';
import { CommentCardModule } from 'src/app/common/comment-card/comment-card.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ButtonModule } from 'src/app/common/button/button.module';
import { StoryV3BannerModule } from 'src/app/common/story-v3-banner/story-v3-banner.module';
import { PaymentModule } from 'src/app/common/payment/payment.module';
import { MatRippleModule } from '@angular/material/core';
import { SocialStripModule } from 'src/app/common/social-strip/social-strip.module';
import { environment } from 'src/environments/environment';
import { ChatWithUsModule } from 'src/app/common/chat-with-us/chat-with-us.module';
import { MatButtonModule } from '@angular/material/button';
import { MultiPatientNoteComponent } from 'src/app/common/multi-patient-note/multi-patient-note.component';
import { DonateNowModule } from 'src/app/common/donate-now/donate-now.module';
import { PaymentUtilService } from 'src/app/common/payment/services';

@Component({
  selector: 'app-story-ab',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    BannerModule,
    PlaceholderLoaderModule,
    StoryModule,
    HospitalDoctorContactModule,
    StoryDocsModule,
    InViewportModule,
    SipTopBannerModule,
    EndFundraiserBannerModule,
    FundraiserSIPBannerModule,
    ThankyouBannerModule,
    ModuleLoaderModule,
    MatExpansionModule,
    BenficiaryCardModule,
    ComponentLoader,
    DonationMethodsModule,
    ReferFriendModule,
    CommentCardModule,
    ButtonModule,
    StoryV3BannerModule,
    PaymentModule,
    MatRippleModule,
    SocialStripModule,
    ChatWithUsModule,
    MatButtonModule,
    MultiPatientNoteComponent,
    DonateNowModule
  ],
  templateUrl: './story-ab.component.html',
  styleUrls: ['./story-ab.component.scss']
})
export class StoryAbComponent {
  @Input() fundraiser: IFundraiser;
  @Input() updates;
  @Input() hide_el;
  @Input() campaignUrl;
  @Input() isDonated;
  @Input() basicInfo;
  @Input() sharedCounts;
  @Input() currency;
  @Input() beneficiary;
  @Input() qParams;
  @Input() currencyInfo;
  @Input() customTag;
  @Input() paymentDialogType = 'onpage';
  theaterImage = '';
  tabIndex = 0;
  isSipStory = false;
  thankYouBanner: any;
  userData: IUser;
  miniStory = false;
  isMicroSite;

  public vwo = inject(VwoService);
  private paymentUtilService = inject(PaymentUtilService);

  isFundraiserEnded = false;
  @ViewChild('youtubeEmbed') youtubeEmbed;
  util = inject(UtilService);
  public vars = inject(VariablesService);
  isMobile = false;
  isLoggedIn = false;
  isSipSubscribed = false;
  subs = [];
  comments;
  inViewPort = {
    'docs': false,
    'comments': false,
    'twitter': false,
    'expense': false
  };
  lastScrollTop = 0;

  fundraiserService = inject(FundraiserService);
  api = inject(ApiService);

  ngOnInit() {
    this.setTheatreImage();
    this.isMobile = this.util.isMobile();
    this.checkUserLogin();
    this.util.doc?.body?.classList?.add('dmsans');
    this.isMicroSite = this.util.isMicroSite();
    if (this.isMobile) {
      this.util.doc?.body?.classList?.add('dock-visible-mb-60');
    }
    if (this.qParams?.st === 'f' && !this.vars.thirdPartyApp) {
      this.paymentUtilService.isSubmitted.next(true);
    }
  }

  /**On window scroll */
  @HostListener('window:scroll', []) onWindowScroll() {
    const _el = document.getElementById('urgentSlide');
    if (_el) {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      if (this.vars.showKCart) {
        _el.style.bottom = st > this.lastScrollTop ? '0' : '95px';
      } else {
        _el.style.bottom = st > this.lastScrollTop ? '0' : this.vars?.fundraiser?.is_multi_patient_campaign ? '88px' : '65px';
      }
      this.lastScrollTop = st <= 0 ? 0 : st;
    }
  }

  getFirstName(name: string) {
    return name ? name.split(' ')[0] : '';
  }

    /**check user logged in status */
  checkUserLogin() {
    this.util.isLoggedIn.subscribe((res) => {
      this.isLoggedIn = res;
      this.checkForMedDoc();
    });
    this.subs.push(this.vars.userData.subscribe({
      next: (res) => {
        if (typeof window !== 'undefined' && res) {
          this.userData = res;
          if (this.userData.aggdonationall && this.userData.aggdonationall.funds) {
            (<any>window).repeatedDonor = true;
          }
          this.isSipSubscribed = [1, 2].includes(res?.listsubscriptions?.medical?.status_flag);
        }
      }
    }));
  }

    /**In view port */
  inViewPortListner(e, type) {
    if (this.fundraiser && e.visible === true && !this.inViewPort[type] && this.util.isBrowser) {
      if (type === 'comments') {
        this.getFundraiserCommnets(this.customTag);
      }
      this.inViewPort[type] = true;
    }
  }

  
  /**Get the fundraiser comments */
  getFundraiserCommnets(customTag) {
    const qParam = '?limit=5';
    this.fundraiserService.getFundraiserComments(customTag, qParam).subscribe((res: any) => {
      this.comments = res.data;
    });
  }

   /**check the length of the array */
   checkLength(arr) {
    return arr && arr.length ? true : false;
  }

  setTheatreImage() {
    if (this.fundraiser?.theater) {
      this.theaterImage = this.fundraiser?.theater.cdn_path;
    } else {
      const gallery = this.fundraiser ? this.fundraiser?.gallery : [];
      this.theaterImage = gallery && gallery.length ? gallery[0].cdn_path : this.util.defaultBlurImg;
    }
  }

  scrollToVideo(event) {
    if (event) {
      this.youtubeEmbed.nativeElement.scrollIntoView({
        behavior: 'smooth', block: 'center'
      });
    }
  }

  getTabIndex(event): void {
    this.tabIndex = event;
  }

  checkForMedDoc() {
    if (this.userData && !this.fundraiser?.viewmedicalbill?.length && this.fundraiser?.count_medical_bill) {
      const url = environment.APP.API_URLS.GET_MEDICAL_BILL(this.vars.fundraiser.id);
      this.api.get(url).subscribe({
        next: (resp: any) => {
          this.fundraiser.viewmedicalbill = resp?.data || [];
          this.vars.fundraiser.viewmedicalbill = this.fundraiser.viewmedicalbill;
        },
        error: (err: any) => {}
      })
    }
  }

  reportProject() {
    const url = this.util.domain_details.domain_url + `/support/contact-us.php?contact_ref=abuse&campaign_id=${this.fundraiser.id}&campaign=${this.fundraiser.custom_tag}`;
    this.util.nativeNavigation(url, true);
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
    this.util.doc?.body?.classList?.remove('dmsans');
    if (this.isMobile) {
      this.util.doc?.body?.classList?.remove('dock-visible-mb-60');
    }
  }
}
